<nav class="sidebar-menu">
  <ul class="sidebar-menu__list">
    @for (menuItem of menuItems; track menuItem) {
      <li>
        <a class="sidebar-menu__list__item" [routerLink]="menuItem.url" [class.current]="isCurrent(menuItem)">
          <span class="sidebar-menu__list__item__svg">
            <svg-icon class="svgImage" [applyClass]="true" [src]="'/assets/img/icons/' + menuItem.icon + '.svg'" />
          </span>
          <span class="sidebar-menu__item__text">{{ menuItem.title }}</span>
        </a>
      </li>
    }
  </ul>
</nav>
